<template lang="pug">
	keep-alive
		.matrixFilter(:class="{selected}", @click.stop="select")
			.matrixFilter-checkbox
			span.matrixFilter-text {{data.tag}}
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "MatrixFilter",
  props: ["data", "id"],
  computed: {
    ...mapGetters(["filters"]),
    selected() {
      if (this.filters[this.id]) {
        if (this.filters[this.id][this.data.tag]) return true;
      }
      return false;
    }
  },
  methods: {
    ...mapMutations(["loadFilters"]),
    select() {
      let payload = {
        id: this.id,
        tag: this.data.tag,
        data: this.data.values
      };
      this.loadFilters(payload);
    }
	}
};
</script>

<style lang="scss" scoped>
.matrixFilter {
  padding: 3px 0;
	flex: 0 0 auto;
  display: flex;
  align-items: center;
  cursor: pointer;
  max-width: 100%;
  &.selected {
    .matrixFilter-checkbox:after {
      opacity: 1;
    }
  }
  @media (min-width: 1100px) {
    padding: 0.5rem 0.5rem;
    &:hover {
      background: palette(azure, 400);
    }
  }
}

.matrixFilter-checkbox {
  height: 20px;
  width: 20px;
  flex: 0 0 20px;
  position: relative;
  border: 1px solid;
  margin-right: 0.25rem;
  @media (min-width: 1100px) {
    color: $white;
		height: 12px;
		width: 12px;
		flex: 0 0 12px;
  }
  &:after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 2px;
    margin: auto;
    box-sizing: content-box;
    width: 2px;
    height: 6px;
    content: "";
    transition: opacity 0.2s ease;
    transform: rotate(45deg);
    opacity: 0;
    border-right: 1px solid;
    border-bottom: 1px solid;
  }
}

.matrixFilter-text {
  position: relative;
  display: inline-block;
  overflow: hidden;
  cursor: pointer;
  transition: 0.2s ease;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (min-width: 1100px) {
    color: $white;
		font-size: 13px;
		line-height: 1.3;
  }
}
</style>